import React, { useEffect, useState } from 'react';
import { anmeldeStoerung } from './hilfeApi';
import { stoerungStatusSatz, stoerungTitelSatz } from './hilfeTexte';

// Hinweis auf der Anmeldeseite (Profil-Nachbau F-06, TEIL-3 SP3-05; PF-311-1): ist der Bereich „Anmeldung“ gestört, nennt die
// Seite Titel und Status, ohne Anmeldung und ohne weitere Daten (GET /api/public/stoerungen/anmeldung). Bei Fehler nichts.
export default function AnmeldeStoerung() {
  const [stoerung, setStoerung] = useState<{ titel: string; status: string } | null>(null);

  useEffect(() => {
    const abbruch = new AbortController();
    anmeldeStoerung(abbruch.signal)
      .then(daten => { if (!abbruch.signal.aborted) setStoerung(daten.stoerung); })
      .catch(() => undefined);
    return () => abbruch.abort();
  }, []);

  if (!stoerung) return null;
  return <div className="login-notice notice" role="status"><strong>{stoerungTitelSatz(stoerung.titel)}</strong><span>{stoerungStatusSatz(stoerung.status)}</span></div>;
}
